export default __webpack_public_path__ + "979719cabf3edc3f9c74ca22a5bfbca2.png";